import { forwardRef, Ref, type SVGProps } from 'react';

const SvgMembershipTierHero = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 56 56"
    ref={ref}
    {...props}
  >
    <rect
      width={56}
      height={56}
      fill="url(#membership-tier-hero_svg__a)"
      rx={12}
    />
    <path
      fill="url(#membership-tier-hero_svg__b)"
      d="M38.633 33.516q0 2.678-2.013 4.58-2.012 1.905-4.843 1.904H17.371v-6.804l4.808-1.954H17.37v-8.758q0-2.694 2.012-4.58Q21.396 16 24.226 16h14.406v6.804l-4.807 1.954h4.807v8.757"
    />
    <defs>
      <linearGradient
        id="membership-tier-hero_svg__a"
        x1={28}
        x2={28}
        y1={0}
        y2={108}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#195850" />
        <stop offset={1} stopColor="#022420" />
      </linearGradient>
      <linearGradient
        id="membership-tier-hero_svg__b"
        x1={28.002}
        x2={28.002}
        y1={16}
        y2={85.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C7F50A" />
        <stop offset={1} stopColor="#748F06" />
      </linearGradient>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgMembershipTierHero);
export default ForwardRef;
